<div mat-dialog-title>We're sorry to hear that. What's the issue?</div>

<div mat-dialog-content>
  <mat-selection-list #optionList>
    @for (option of options; track option; let i = $index) {
      <mat-list-option togglePosition="before" [value]="i">{{ option }}</mat-list-option>
    }
  </mat-selection-list>
  <mat-form-field>
    <textarea matInput placeholder="Please tell us more about your issue" #otherIssue></textarea>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="sendFeedback({ options: optionList._value, otherIssue: otherIssue.value })">
    Send feedback
  </button>
</div>
